<template>
    <v-card>
        <v-layout row wrap justify-end>
            <v-btn
            flat
            icon
            @click="fechar"
            color="primary"
            >
                <v-icon>close</v-icon>
            </v-btn>
        </v-layout>
        <v-layout row wrap justify-center>
            <v-flex xs12 class="text-xs-center headline font-weight-light primary--text mb-3">
                Enviar email para clientes
            </v-flex>
        </v-layout>
        <v-card-text
            class="pt-4"
            style="position: relative;"
        >

            <v-flex v-if="pessoa" xs12 class="text-xs-center font-weight-light primary--text mb-3">
                {{`${pessoa.nome} ${pessoa.sobrenome}`}}
            </v-flex>

            <v-text-field
                v-model="mail.subject"
                label="Assunto"
                outline
                clearable
            />

            <v-textarea
                v-model="mensagem"
                label="Mensagem"
                outline
                height="250"
            />

            <v-divider></v-divider>

            <v-autocomplete
                v-model="opicao"
                :items="[opicao]"
                chips
                label="Destinatário"
                readonly
                full-width
                hide-details
                hide-no-data
                hide-selected
            />

        </v-card-text>
        <v-card-actions>
            <v-layout row wrap justify-end>
                <v-btn color="primary" @click="enviar">Enviar <v-icon style="margin-left: 5px;">send</v-icon></v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ['pessoa'],
    data () {
        return {
            mensagem: '',
            opicao: 'Todos os Clientes',
            mail: {
                to: '',
                message: '',
                subject: ''
            }
        }
    },
    mounted () {
        if (this.pessoa) {
            this.mail.to = this.pessoa.email
            this.opicao = this.pessoa.email
        }
    },
    methods: {
        enviar () {
            this.mail.message = this.mensagem
            this.mail.message = this.mail.message.replace(/\n/g, '<br/>')
            if (this.pessoa) {
                this.mail.to = this.pessoa.email
            }
            this.$store.dispatch('enviarEmailParaUsuarios', this.mail).then((status) => {
                this.limparCampos()
                this.$emit('sucess', 'Email enviado com sucesso')
            }).catch((erro) => {
                if (erro.message === '400') {
                    this.$emit('erro', 'Não foi possível enviar email')
                } else {
                    this.$emit('erro', 'Não existe um clinte registrado com esse email')
                }
            })
        },

        limparCampos () {
            this.mensagem = ''
            this.mail.message = ''
            this.mail.subject = ''
            this.mail.to = ''
        },

        fechar () {
            this.limparCampos()
            this.$emit('fechar')
        }
    }
}
</script>
